import { colors } from 'theme'

export const defaultThemeStyles = {
    online: colors.online,
    offline: colors.offline,
    error: colors.error,
    updating: colors.warning,
    notSynchronized: colors.notSynchronized,
    sleep: colors.sleep,
}
